import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2079_4737)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M10.6666 5.33722V3.47055C10.6666 2.72382 10.6666 2.35045 10.5213 2.06523C10.3934 1.81435 10.1895 1.61038 9.93857 1.48254C9.65336 1.33722 9.27999 1.33722 8.53325 1.33722H3.46659C2.71985 1.33722 2.34648 1.33722 2.06126 1.48254C1.81038 1.61038 1.60641 1.81435 1.47858 2.06523C1.33325 2.35045 1.33325 2.72382 1.33325 3.47055V8.53722C1.33325 9.28396 1.33325 9.65732 1.47858 9.94254C1.60641 10.1934 1.81038 10.3974 2.06126 10.5252C2.34648 10.6706 2.71985 10.6706 3.46659 10.6706H5.33325M7.46658 14.6706H12.5333C13.28 14.6706 13.6534 14.6706 13.9386 14.5252C14.1895 14.3974 14.3934 14.1934 14.5213 13.9425C14.6666 13.6573 14.6666 13.284 14.6666 12.5372V7.47055C14.6666 6.72382 14.6666 6.35045 14.5213 6.06523C14.3934 5.81435 14.1895 5.61037 13.9386 5.48254C13.6534 5.33722 13.28 5.33722 12.5333 5.33722H7.46658C6.71985 5.33722 6.34648 5.33722 6.06126 5.48254C5.81038 5.61037 5.60641 5.81435 5.47858 6.06523C5.33325 6.35045 5.33325 6.72382 5.33325 7.47055V12.5372C5.33325 13.284 5.33325 13.6573 5.47858 13.9425C5.60641 14.1934 5.81038 14.3974 6.06126 14.5252C6.34648 14.6706 6.71985 14.6706 7.46658 14.6706Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2079_4737",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0 0.00390625)"
		})
	}) })]
});
export default SvgCopy;
